import { useEffect, useState } from 'react';
import { Box, Typography, Popover, ListItemButton, ListItemText, Avatar } from '@mui/material';
import PropTypes from 'prop-types';

import Iconify from '../../components/iconify';
import axiosInstance from '../../api';
import SERVER_API_URL from '../../config';

export default function RegisteredBy({ openRegister, registeredBy, handleCloseMenu }) {
  const [avatar, setAvatar] = useState();

  const getAvatar = async (userId) => {
    try {
      const response = await axiosInstance.get(`${SERVER_API_URL}/avatar/getAvatarById/${userId}`, {
        responseType: 'blob',
      });
      if (response.status === 200) {
        const url = URL.createObjectURL(response.data);
        setAvatar(url);
      }
    } catch (e) {
      setAvatar(null);
    }
  };

  useEffect(() => {
    getAvatar(registeredBy.id);
  }, [registeredBy]);

  return (
    <Popover
      open={Boolean(openRegister)}
      anchorEl={openRegister}
      onClose={handleCloseMenu}
      anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      PaperProps={{
        sx: {
          p: 1,
          '& .MuiMenuItem-root': {
            px: 1,
            typography: 'body2',
            borderRadius: 0.75,
          },
        },
      }}
    >
      {registeredBy && (
        <>
          <Box sx={{ display: 'flex', mb: 2 }}>
            <Avatar src={avatar} alt={`${registeredBy.firstName}'s avatar`} />
            <Box sx={{ ml: 2 }}>
              <Typography variant="subtitle2" sx={{ color: 'text.primary' }}>
                {registeredBy.firstName} {registeredBy.lastName}
              </Typography>

              <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                <Iconify icon="carbon:badge" /> - {registeredBy.role.name}
              </Typography>
            </Box>
          </Box>
          <Box sx={{ display: 'flex' }}>
            <Typography variant="subtitle2" sx={{ color: 'darkgray' }}>
              ወረዳ :
            </Typography>
            <Typography variant="subtitle2" sx={{ ml: 1, color: 'text.primary' }}>
              {registeredBy.church.district.name}
            </Typography>
          </Box>
          <Box sx={{ display: 'flex' }}>
            <Typography variant="subtitle2" sx={{ color: 'darkgray' }}>
              አጥቢያ :
            </Typography>
            <Typography variant="subtitle2" sx={{ ml: 1, color: 'text.primary' }}>
              {registeredBy.church.name}
            </Typography>
          </Box>
          <Box sx={{ display: 'flex' }}>
            <Typography variant="subtitle2" sx={{ color: 'darkgray' }}>
              ምድብ :
            </Typography>
            <Typography variant="subtitle2" sx={{ color: registeredBy.category.color, ml: 1 }}>
              {registeredBy.category.name}
            </Typography>
          </Box>
          <Box sx={{ display: 'flex' }}>
            <Typography variant="subtitle2" sx={{ color: 'darkgray' }}>
              ስልክ ቁጥር :
            </Typography>
            <Typography variant="subtitle2" sx={{ ml: 1, color: 'text.primary' }}>
              {registeredBy.phone}
            </Typography>
          </Box>
          {registeredBy.email && (
            <Box sx={{ display: 'flex' }}>
              <Typography variant="subtitle2" sx={{ color: 'darkgray' }}>
                ኢሜይል :
              </Typography>
              <Typography variant="subtitle2" sx={{ ml: 1, color: 'text.primary' }}>
                {registeredBy.email}
              </Typography>
            </Box>
          )}
          <Box sx={{ display: 'flex' }}>
            <Typography variant="subtitle2" sx={{ color: 'darkgray' }}>
              ሁኔታ :
            </Typography>
            <Typography variant="subtitle2" sx={{ ml: 1, color: 'text.primary' }}>
              {registeredBy.status}
            </Typography>
          </Box>
        </>
      )}
      {!registeredBy && (
        <ListItemButton
          sx={{
            py: 1.5,
            px: 2.5,
            mt: '1px',
          }}
        >
          <ListItemText primary="መዝጋቢ የለውም።" />
        </ListItemButton>
      )}
    </Popover>
  );
}

RegisteredBy.propTypes = {
  openRegister: PropTypes.bool.isRequired,
  registeredBy: PropTypes.object,
  handleCloseMenu: PropTypes.func.isRequired,
};
